import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => {
  const stacked = `@media (max-width: ${theme.screens.small_desktop - 1}px)`;
  return {
    billing: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4)
    },
    // Same split as the workspace Overview: schedules on the left, price and methods on the right.
    columns: {
      display: 'grid',
      gridTemplateColumns: `minmax(0, 1fr) ${theme.sizes.sideColumn}px`,
      gap: theme.spacing(8),
      alignItems: 'start',
      [stacked]: { gridTemplateColumns: 'minmax(0, 1fr)' }
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
      minWidth: 0
    },
    card: {
      padding: theme.spacing(5, 6),
      minWidth: 0
    },
    facts: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
      gap: theme.spacing(4, 6),
      margin: 0
    },
    fact: {
      minWidth: 0,
      '& dt': {
        fontSize: 13,
        color: theme.colorPalette.beige_90,
        marginBottom: theme.spacing(1)
      },
      '& dd': {
        margin: 0,
        fontSize: 15,
        fontWeight: 600,
        color: theme.colors.page__title
      }
    },
    pastDue: {
      color: theme.colors.error
    },
    methodLine: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    summaryWarning: {
      margin: theme.spacing(4, 0, 0),
      fontSize: 14,
      color: theme.colors.error
    },
    cardHeader: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: theme.spacing(2, 4)
    },
    cardTitle: {
      display: 'flex',
      alignItems: 'baseline',
      gap: theme.spacing(3)
    },
    heading: {
      margin: 0
    },
    policyId: {
      fontSize: 13,
      color: theme.colorPalette.beige_90,
      fontVariantNumeric: 'tabular-nums'
    },
    actions: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1, 4),
      margin: theme.spacing(2, 0, 3)
    },
    action: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    actionLink: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.colors.action_text,
      textDecoration: 'none',
      '&:hover, &:focus-visible': {
        textDecoration: 'underline',
        textUnderlineOffset: '3px'
      }
    },
    errorBody: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(3),
      marginTop: theme.spacing(3),
      color: theme.colors.error
    },
    muted: {
      margin: 0,
      fontSize: 14,
      color: theme.colorPalette.beige_90
    },
    subText: {
      display: 'block',
      fontSize: 13,
      color: theme.colorPalette.beige_90
    },
    priceBlock: {
      '& + &': {
        marginTop: theme.spacing(5),
        paddingTop: theme.spacing(5),
        borderTop: `1px solid ${theme.colorPalette.beige_60}`
      }
    },
    priceRows: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) auto',
      gap: theme.spacing(1.5, 4),
      margin: theme.spacing(3, 0, 0),
      fontSize: 14,
      '& dd': {
        margin: 0,
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums'
      }
    },
    total: {
      fontWeight: 700
    },
    methods: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3)
    },
    method: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(3)
    },
    methodName: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    srOnly: {
      position: 'absolute',
      width: 1,
      height: 1,
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      whiteSpace: 'nowrap'
    }
  };
};

export default makeStyles(styles);
